

export const LanguageSelectorData  = [
    {code: 'en', label: 'English', icon: null},
    {code: 'fr', label: 'Français', icon: null},

];
